// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3eORN","imageUploader":"EGiftCard_imageUploader__2WIKZ"};